import React, { useContext, useEffect, useRef } from 'react'
import { Route, Routes, useLocation, useSearchParams } from 'react-router-dom'
import { AppContext } from '../context/app'
import Header from '../components/header'
import Footer from '../components/footer'
import Home from '../container/home'
import Player from '../container/player/player'
import Faq from '../container/staticPages/faq'
import Search from '../container/search'
import Favorites from '../container/favorite'
import Watchlist from '../container/watchlist'
import ProfilePage from '../container/profile'
import PaymentPage from '../container/paymentPage'
import ContentListing from '../container/contentListing'
import { SubscriptionContext } from '../context/subscription'
// import LoginRegister from '../components/auth/loginRegister'
import CategoryListingView from '../container/categoryView'
import CommonStaticPage from '../container/staticPages/CommonStaticPage'
import PaymentStatus from '../container/paymentPage/paymentStatus'
import ArtistDetail from '../container/artist/artistDetail'
import VenueDetail from '../container/venue/venueDetail'
import MyTransactions from '../container/myPlans/myTransactions'
import LanguageModal from '../components/multiLanguage/languageModal'
import { Helmet } from 'react-helmet'
import { getImage, PREVIOUS_PATH_KEY, raiseToast } from '../utils/helper'
import ResetPassword from '../container/reset-password'
import ForgotPassword from '../components/auth/forgotPassword'
import AccountDisable from '../components/accountDisabled'
import TemplateHome from '../container/template'
import defaultTheme from '../components/themes/defaultTheme'
import magentaHighlight from '../components/themes/magentaHighlight'
import neonDark from '../components/themes/neonDark'
import pantoneRed from '../components/themes/pantoneRed'
import darkInfraRed from '../components/themes/darkInfraRed'
import greenEnergy from '../components/themes/greenEnergy'
import { TemplateContext } from '../context/template'
import { ThemeProvider } from 'theming'
import OpaqueHeader from '../components/template/rosemary/opaqueHeader'
import ParallelFooter from '../components/template/rosemary/parallelFooter'
import CrystallineHeader from '../components/template/fitness/crystallineHeader'
import ConventionalFooter from '../components/template/fitness/conventionalFooter'
import ShadowBGFooter from '../components/template/gaming/shadowBGFooter'
import FullScreenLoader from '../components/fullscreenLoader'
import UIMediaHeader from '../components/template/uimedia/uiMediaHeader'
import UImediaFooter from '../components/template/uimedia/uimediaFooter'
import PlaylistHome from '../container/playlist'
import IFrameVideo from '../container/contentDetail/IFrameVideo'
import IframeModal from '../components/iframeModal'
import ATGHeader from '../components/template/atg/atgHeader'
import DefaultFooter from '../components/template/default/defaultFooter'
import { isEmpty } from 'lodash'
import VerifyEmailStatus from '../container/profile/verifyEmail'
import CustomPage from '../container/customPage/customPage'
// import Channel from '../container/channel'
import ChannelListing from '../container/channel/channelListing'
import CustomForm from '../components/customForm'
import MiamiFoxFooter from '../components/template/miamiFox/miamiFoxFooter'
import MiamiFoxHeader from '../components/template/miamiFox/miamiFoxHeader'
import NewCrystallineHeader from '../components/template/fitness/newCrystallineHeader'
import PlayerPage from '../container/playerPage'
import ShareModal from '../components/shareModal/shareModal'
import NewOpaqueHeader from '../components/template/rosemary/newOpaqueHeader'
import AppFocusedFooter from '../components/template/default/appFocusedFooter'
import NewCrystallineHeaderLeftAligned from '../components/template/fitness/newCrystalineHeaderLeftAligned'
import RouteChangeTracker from '../routeChangeTracker'
import NewOpaqueHeaderLeftAligned from '../components/template/rosemary/newOpaqueHeaderLeftAligned'
import SystemMetadata from '../container/metadata/systemMetadata'
import LoginTemplate from '../container/login'
import PricingPage from '../container/pricing'
import MyPlans from '../container/myPlans/myPlans'
import RegisterTemplate from '../container/register'
import ContentDetailTemplate from '../container/contentDetail'
import MultiPartDetailTemplate from '../container/multiPartDetail'
import SubscriptionModal from '../components/pricing/subscriptionModal'
import MultiPartPlayer from '../container/multipartPlayer'
import ArtistTemplate from '../container/artist/artistTemplate'
import VerifyEmailModal from '../components/verifyEmailModal'
import VenueTemplate from '../container/venue/venueTemplate'
import { useTranslation } from 'react-i18next'
import SportsHeader from '../components/template/default/sportsHeader'
import LiveMatches from '../container/fanstasyLeague/liveMatches'
import Contests from '../container/fanstasyLeague/contests'
import StillWatchingOverlay from '../components/stillWatchiingOverlay/stillWatchingOverlay'
import TipJarModal from '../components/tipJarModal'
import AtomicFooter from '../components/template/default/atomicFooter'
import MagazineStyleHeader from '../components/template/default/magazineStyleHeader'
import ProductDetail from '../container/e-commerce/productDetail'
import OrderHistory from '../container/e-commerce/orderHistory'
import WishList from '../container/e-commerce/wishList'
import ManageAddress from '../container/e-commerce/manageAddress'
import CartDetails from '../container/e-commerce/cartDetails'
import EcommPaymentStatus from '../container/e-commerce/ecommPaymentStatus'
import StoreTemplate from '../container/e-commerce/storeTemplate'
import EcommMetaData from '../container/e-commerce/ecommMetaData'
import MagazineStyleHeaderTenOptions from '../components/template/default/magazineStyleHeaderTenOptions'
// import IPTV from '../container/iptv'
import NewRightHeader from '../components/template/fitness/newRightHeader'
import LoginTemplateModal from '../container/loginModal'
import MagazineStyleHeaderNewIKIM from '../components/template/default/magazineStyleHeaderNewIKIM'
import IkimHeader1 from '../components/template/ikim/ikimHeader1'
import IkimHeader2 from '../components/template/ikim/ikimHeader2'
import IkimHeader4 from '../components/template/ikim/ikimHeader4'
import RasperHeader from '../components/template/default/rasperHeader'
import PoleHome from '../container/pole'
import VrPlayer from '../container/vr-player'
// import IptvPlaylist from '../container/iptv/iptvPlaylist'
import IptvTemplate from '../container/iptv/iptvTemplate'
import AthleteCarouselHeader from '../components/template/default/athleteCarouselHeader'
import BundleProductAddressModal from '../components/pricing/bundleProductAddressModal'
import AthleteOwnedSportsHeader from '../components/template/aoSports/athleteOwnedSportsHeader'

const themes = [defaultTheme, magentaHighlight, neonDark, pantoneRed, darkInfraRed, greenEnergy]

const Routing = () => {
  const {
    isLogin,
    openLoginModal,
    loader,
    languageModal,
    accountObj,
    openForgotPasswordModal,
    isAccountInactive,
    isCustomTemplate,
    popupModalLink,
    tipJarModalConfig,
    shareModalData,
    verifyOtpModalData,
    openAreYouStillWatching,
    setLastMouseMovedSec,
    modulePermissions,
    setAthleteHeaderData,
    bundleProductsModalData,
  } = useContext(AppContext)
  const { t } = useTranslation()
  const { componentData, themeIndex, templateLoader } = useContext(TemplateContext)
  const [searchParams] = useSearchParams()
  const { openSubscriptionModal } = useContext(SubscriptionContext)
  const [isApp, setIsApp] = React.useState(false)
  // const isIptvPlaylistAllowed = accountObj?.od_resource_allowances?.is_iptv_playlist_allowed

  const location = useLocation()
  const currentPathRef = useRef(location.pathname)
  useEffect(() => {
    window.scrollTo(0, 0)
    if (currentPathRef.current !== location.pathname) {
      sessionStorage.setItem(PREVIOUS_PATH_KEY, currentPathRef.current)
      currentPathRef.current = location.pathname
    }
    if (!location.pathname.includes('athlete')) {
      setAthleteHeaderData({})
    }
  }, [location])

  useEffect(() => {
    if (searchParams.get('is_app') === 'true') {
      setIsApp(true)
    } else {
      setIsApp(false)
    }
  }, [])

  useEffect(() => {
    if (
      isLogin &&
      (location.pathname.includes('login') ||
        location.pathname.includes('signup') ||
        location.pathname.includes('reset-password'))
    ) {
      raiseToast('success', t('already_logged_in'))
    }
  }, [location, isLogin])

  const isIFrame = () => location.pathname.includes('embed')
  const getHeaderFooter = (type) => {
    if (templateLoader || isEmpty(accountObj) || loader) {
      return
    }

    if (isCustomTemplate) {
      let customComponentObj = componentData.find((info, index) =>
        info?.data?.component_key.includes(type),
      )
      if (customComponentObj) {
        let componentProps = {
          componentData: customComponentObj?.data,
          modifyData: () => {},
          setModalState: () => {},
          isEdit: false,
          onSwap: () => {},
          onDelete: () => {},
          onCopy: () => {},
        }
        let componentObj = {
          opaqueHeader: <OpaqueHeader {...componentProps} />,
          parallelFooter: <ParallelFooter {...componentProps} />,
          crystallineHeader: <CrystallineHeader {...componentProps} />,
          conventionalFooter: <ConventionalFooter {...componentProps} />,
          shadowBGFooter: <ShadowBGFooter {...componentProps} />,
          uiMediaHeader: <UIMediaHeader {...componentProps} />,
          UIMediaFooter: <UImediaFooter {...componentProps} />,
          atgHeader: <ATGHeader {...componentProps} />,
          defaultFooter: <DefaultFooter {...componentProps} />,
          miamiFoxHeader: <MiamiFoxHeader {...componentProps} />,
          miamiFoxFooter: <MiamiFoxFooter {...componentProps} />,
          newCrystallineHeader: <NewCrystallineHeader {...componentProps} />,
          newOpaqueHeader: <NewOpaqueHeader {...componentProps} />,
          appFocusedFooter: <AppFocusedFooter {...componentProps} />,
          newCrystallineHeaderLeft: <NewCrystallineHeaderLeftAligned {...componentProps} />,
          newCrystallineHeaderLeftClone: <NewCrystallineHeaderLeftAligned {...componentProps} />,
          newOpaqueHeaderLeft: <NewOpaqueHeaderLeftAligned {...componentProps} />,
          newOpaqueHeaderLeftClone: <NewOpaqueHeaderLeftAligned {...componentProps} />,
          sportsHeader: <SportsHeader {...componentProps} />,
          atomicFooter: <AtomicFooter {...componentProps} />,
          magazineStyleHeader: <MagazineStyleHeader {...componentProps} />,
          magazineStyleHeaderTenOptions: <MagazineStyleHeaderTenOptions {...componentProps} />,
          rightAlignedHeader: <NewRightHeader {...componentProps} />,
          MagazineStyleHeaderNewIKIM: <MagazineStyleHeaderNewIKIM {...componentProps} />,
          ikimHeader: <IkimHeader1 {...componentProps} />,
          ikimHeader2: <IkimHeader2 {...componentProps} />,
          ikimHeader3: <IkimHeader2 {...componentProps} isReverse={true} />,
          ikimHeader4: <IkimHeader4 {...componentProps} />,
          rasperHeader: <RasperHeader {...componentProps} />,
          athleteCarouselHeader: <AthleteCarouselHeader {...componentProps} />,
          athleteOwnedSportsHeader: <AthleteOwnedSportsHeader {...componentProps} />,
        }
        return componentObj[customComponentObj?.data?.component_key]
      }
      return
    }
    let basicComponentObj = {
      Header: <Header />,
      Footer: <Footer />,
    }
    return basicComponentObj[type]
  }

  return (
    <div
      className={`flex flex-col ${isIFrame() ? 'min-h-max' : 'min-h-screen'}`}
      style={{ background: themes[themeIndex].c1 }}
      onMouseMove={() => setLastMouseMovedSec(0)}
    >
      {!isEmpty(accountObj) && <RouteChangeTracker />}
      <ThemeProvider theme={themes[themeIndex]}>
        <FullScreenLoader
          loading={loader}
          color={templateLoader ? '#000' : 'rgba(60, 60, 60, 0.6)'}
        />
        {!isApp && !isIFrame() && getHeaderFooter('Header')}
        <Helmet>
          <title>{`${
            accountObj?.account_metadata ? accountObj?.account_metadata?.title : 'title'
          }`}</title>
          <meta
            name="description"
            content={`${accountObj?.account_metadata && accountObj?.account_metadata?.description}`}
          />
          <link
            rel="icon"
            type="image/png"
            href={
              accountObj?.cf_domain_name &&
              getImage(accountObj?.cf_domain_name, 'public/static/favicon.png')
            }
            sizes="16x16"
          />
        </Helmet>
        <main className="flex-grow">
          {(loader || isEmpty(accountObj)) && <div style={{ minHeight: '100vh' }}></div>}
          <Routes>
            {!isAccountInactive ? (
              <>
                <Route path="/" element={isCustomTemplate ? <TemplateHome /> : <Home />} />
                <Route path="home" element={isCustomTemplate ? <TemplateHome /> : <Home />} />
                <Route path="content/:contentId" element={<ContentDetailTemplate />} />
                <Route path="embed/:contentId" element={<IFrameVideo />} />
                <Route path="parent-content/:contentId" element={<MultiPartDetailTemplate />} />
                <Route path="category/:categoryId" element={<CategoryListingView />} />
                <Route path="metadata/:categoryId" element={<SystemMetadata />} />
                <Route
                  path="ecommerce-metadata/:categoryName/:categoryId"
                  element={<EcommMetaData />}
                />
                <Route path="sub-category/:categoryId" element={<SystemMetadata />} />
                <Route path="content/filter/:filterName" element={<ContentListing />} />
                <Route path="watch/:contentId" element={<Player />} />
                <Route path="about-us" element={<CommonStaticPage />} />
                <Route path="term-of-use" element={<CommonStaticPage />} />
                <Route path="privacy-policy" element={<CommonStaticPage />} />
                <Route path="copyright" element={<CommonStaticPage />} />
                <Route path="faq" element={<Faq />} />
                <Route path="search" element={<Search />} />
                <Route path="artists" element={<ArtistTemplate />} />
                <Route path="venues" element={<VenueTemplate />} />
                <Route path="channels" element={<ChannelListing />} />
                <Route path="artist/detail/:artistId" element={<ArtistDetail />} />
                <Route path="venue/detail/:venueId" element={<VenueDetail />} />
                <Route path="playlist/:playlistId" element={<PlaylistHome />} />
                {/* <Route path="channel/:channelId" element={<Channel />} /> */}
                <Route path="custom/:pageURL" element={<CustomPage />} />
                <Route path="athlete/:pageURL" element={<CustomPage />} />
                <Route path="content-listing/:pageURL" element={<CustomPage />} />
                <Route path="pricing-page/:pageURL" element={<CustomPage />} />
                <Route path="static/:pageURL" element={<CustomPage />} />
                <Route path="e-comm-page/:pageURL" element={<CustomPage />} />
                <Route path="live-matches" element={<LiveMatches />} />
                <Route path="contests" element={<Contests />} />
                <Route path="carta" element={<PoleHome />} />
                <Route path="vr-player" element={<VrPlayer />} />
                {/* <Route
                  path="channel/:channelId"
                  element={
                    accountObj?.od_resource_allowances?.is_epg_design_allowed ? (
                      isIptvPlaylistAllowed ? (
                        <IptvPlaylist />
                      ) : (
                        <IPTV />
                      )
                    ) : (
                      <Channel />
                    )
                  }
                /> */}
                <Route path="channel/:channelId" element={<IptvTemplate />} />

                <Route
                  path="content-watch/:contentId"
                  element={accountObj?.od_resource_allowances?.player_page ? <PlayerPage /> : <></>}
                />
                <Route
                  path="series-watch/:contentId"
                  element={
                    accountObj?.od_resource_allowances?.player_page ? <MultiPartPlayer /> : <></>
                  }
                />

                <Route
                  path="reset-password/:resetKey"
                  element={
                    !isLogin ? <ResetPassword /> : isCustomTemplate ? <TemplateHome /> : <Home />
                  }
                />
                <Route
                  path="signup"
                  element={
                    !isLogin ? <RegisterTemplate /> : isCustomTemplate ? <TemplateHome /> : <Home />
                  }
                />
                <Route
                  path="login"
                  element={
                    !isLogin ? <LoginTemplate /> : isCustomTemplate ? <TemplateHome /> : <Home />
                  }
                />
                {modulePermissions?.ecommerce ? (
                  <>
                    <Route path="product/:product_id" element={<ProductDetail />} />
                    <Route path="store" element={<StoreTemplate />} />
                  </>
                ) : null}

                {isLogin && (
                  <>
                    <Route path="favourites" element={<Favorites />} />
                    <Route path="watchlist" element={<Watchlist />} />
                    <Route path="profile" element={<ProfilePage />} />
                    <Route path="pricing" element={<PricingPage />} />
                    <Route path="transactions" element={<MyTransactions />} />
                    <Route path="subscriptions" element={<MyPlans />} />
                    <Route path="payment/:planId" element={<PaymentPage />} />
                    <Route path="payment-status/:data" element={<PaymentStatus />} />
                    <Route path="verify-email/:data" element={<VerifyEmailStatus />} />
                    {modulePermissions?.ecommerce ? (
                      <>
                        <Route path="order-history" element={<OrderHistory />} />
                        <Route path="wish-list" element={<WishList />} />
                        <Route path="manage-address" element={<ManageAddress />} />
                        <Route path="cart-details" element={<CartDetails />} />
                        <Route path="payment-status-ecom/:data" element={<EcommPaymentStatus />} />
                      </>
                    ) : null}
                  </>
                )}
                {/*<Route path="*" element={<Navigate to="/home" replace />} />*/}
              </>
            ) : (
              <Route path="*" element={<AccountDisable />} />
            )}
          </Routes>
        </main>
        {openAreYouStillWatching && <StillWatchingOverlay />}
        {openSubscriptionModal && <SubscriptionModal />}
        {/* {openLoginModal && <LoginRegister />} */}
        {openLoginModal && <LoginTemplateModal />}
        {openForgotPasswordModal && <ForgotPassword />}
        {languageModal && <LanguageModal />}
        {popupModalLink && <IframeModal />}
        {!isEmpty(bundleProductsModalData) && <BundleProductAddressModal />}
        {!isEmpty(tipJarModalConfig) && <TipJarModal />}
        {!isEmpty(verifyOtpModalData) && <VerifyEmailModal />}
        {!isEmpty(shareModalData) && <ShareModal {...shareModalData} />}
        <CustomForm />
        {isCustomTemplate &&
          !isIFrame() &&
          location.pathname !== '/home' &&
          location.pathname !== '/' && <div className="md:py-10 py-4" />}
        {!isApp && !isIFrame() && getHeaderFooter('Footer')}
      </ThemeProvider>
    </div>
  )
}

export default Routing
